import PowerConsumption from "../components/PowerConsumption/PowerConsumption";

const PowerConsumptionPage =() =>{
     
    return(
        <PowerConsumption/>
    )
}

export default PowerConsumptionPage;